import React from 'react';
import Aux from '../../../hoc/auxiliary';
import './button.scss';

export default (props) => {
  let btnClasses = ['btn', props.btnType];
  if (props.classes) {
    btnClasses = [...btnClasses, ...props.classes];
  }
  
  return (
    <Aux>
      <button
        onClick={props.clicked}
        className={btnClasses.join(' ')}>
        {props.children}
      </button>
    </Aux>
  )
}